module.exports = __webpack_public_path__ + "img/product_mb_cn_kr.845cf9a.webp";